<div class="divbox" fxLayoutAlign="center center">
  <mat-card class="box">
    <div>

      <div class="divtitle">
        <mat-card-title class="clstitle">{{titleZone}}</mat-card-title>
      </div>

      <div>
        <form method="post" class="form" #f="ngForm" (ngSubmit)="f.form.valid && onGuardarItm()">
          <mat-card-content class="mat-elevation-z8">
            <mat-form-field class="full-width">
              <mat-label>{{'zone.label' | transloco}}</mat-label>
              <input matInput type="text" name="zone_name" placeholder="{{'zone.label' | transloco}}" [(ngModel)]="name_Input" required
                maxlength="64">
              <mat-error>
                {{'zone.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width" *ngIf="role==1">
              <mat-label>{{'zone.company' | transloco}}</mat-label>
              <mat-select [(value)]="company_Selected" [formControl]="companyControl" required>
                @for (item of lstCompanies; track item) {
                <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                }
              </mat-select>
              <mat-error>
                {{'zone.errorIncorrect' | transloco}}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
              <mat-label>{{'zone.country' | transloco}}</mat-label>
              <mat-select [(value)]="country_Selected" required>
                @for (item of lstCountries; track item) {
                <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                }
              </mat-select>
              <mat-error>
                {{'zone.errorIncorrect' | transloco}}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
              <mat-label>{{'zone.description' | transloco}}</mat-label>
              <input matInput type="text" [(ngModel)]="description" placeholder="description" [formControl]="companyControl">
              <mat-error>
                {{'zone.errorIncorrect' | transloco}}
              </mat-error>
            </mat-form-field>

          </mat-card-content>

          <div style="margin-top: 20px;">
            <div class="button-row" fxLayoutAlign="end">
              <button mat-raised-button color="primary" type="submit">{{'zone.save' | transloco}}</button>
              <button mat-raised-button color="warn" *ngIf="!new" type="button" (click)="onEliminarItm()">{{'zone.delete' | transloco}}</button>
              <button mat-raised-button color="basic" routerLink="/zones">{{'zone.cancel' | transloco}}</button>
            </div>
          </div>
        </form>
      </div>

  </div>
  </mat-card>
</div>
